import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: 'Is my kid too young?',
  a: "Age 10 is the 'Golden Window' for cognitive habits. It's the best time to start."
}, {
  q: 'Does this require a coach?',
  a: 'No, this is designed for parents to implement at home in just 10 minutes.'
}, {
  q: 'How soon will I see results?',
  a: "Most parents see a physical change in their child's 'head hygiene' in the very first game."
}, {
  q: 'Is this a physical book?',
  a: 'It is a digital PDF bundle, accessible instantly on your phone or tablet.'
}, {
  q: 'Does it work for defenders?',
  a: 'While focused on strikers, the scanning protocols apply to every position on the pitch.'
}, {
  q: "What if we don't have a yard?",
  a: "Most drills are 'micro-drills' that can be done in a living room or hallway."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-tactical-surface/30" data-id="element-57">
      <div className="max-w-3xl mx-auto" data-id="element-58">
        <div className="text-center mb-12" data-id="element-59">
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-60">
            FREQUENTLY ASKED QUESTIONS
          </h2>
        </div>

        <div className="space-y-4" data-id="element-61">
          {faqs.map((faq, i) => <div key={i} className="bg-tactical-dark border border-tactical-surface2 rounded-lg overflow-hidden" data-id="element-62">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-tactical-surface transition-colors" data-id="element-63">
                <span className="font-oswald text-xl tracking-wide" data-id="element-64">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-tactical-cyan transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-65" />
              </button>

              <AnimatePresence data-id="element-66">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-67">
                    <div className="px-6 pb-4 text-slate-400 font-inter" data-id="element-68">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}